module.exports = __webpack_public_path__ + "media/images/goll-logo-2019-e7aca287290ed02408aead0996234a98.svg";